import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { isMobile } from "../utils";
import request from "./request"; // export interface ApiGetCompleteStatusResult {}
//QBR-1512
export function getCompleteStatus(_x) { return _getCompleteStatus.apply(this, arguments); }
function _getCompleteStatus() { _getCompleteStatus = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(req) { var resp; return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
    switch (_context.prev = _context.next) {
        case 0:
            _context.next = 2;
            return request.post("/api/v1/quotation/quoteMain/getCompleteStatus", req);
        case 2:
            resp = _context.sent;
            return _context.abrupt("return", resp.data);
        case 4:
        case "end": return _context.stop();
    }
} }, _callee); })); return _getCompleteStatus.apply(this, arguments); }
export function getCreditCardCheckOutRequest(_x2, _x3) { return _getCreditCardCheckOutRequest.apply(this, arguments); } //WeChat Pay
function _getCreditCardCheckOutRequest() { _getCreditCardCheckOutRequest = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(req, language) { var resp; return _regeneratorRuntime.wrap(function _callee2$(_context2) { while (1) {
    switch (_context2.prev = _context2.next) {
        case 0:
            _context2.next = 2;
            return request.post("/api/v1/quotation/quoteMain/getQuoteInfo/paymentVisa/" + req.productCode, Object.assign({}, req, { productCode: undefined, useSubmitTime: true }), { headers: { "Accept-Language": language === "hk" ? "zh-HK" : language === "cn" ? "zh-CN" : "en-US" } });
        case 2:
            resp = _context2.sent;
            return _context2.abrupt("return", resp.data);
        case 4:
        case "end": return _context2.stop();
    }
} }, _callee2); })); return _getCreditCardCheckOutRequest.apply(this, arguments); }
export function getWeChatPayRequest(_x4, _x5) { return _getWeChatPayRequest.apply(this, arguments); }
function _getWeChatPayRequest() { _getWeChatPayRequest = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(req, language) { var resp; return _regeneratorRuntime.wrap(function _callee3$(_context3) { while (1) {
    switch (_context3.prev = _context3.next) {
        case 0:
            _context3.next = 2;
            return request.post("/api/v1/quotation/quoteMain/getQuoteInfo/paymentWechat/" + req.productCode, Object.assign({}, req, { productCode: undefined, useSubmitTime: true, isMobile: isMobile() }), { headers: { "Accept-Language": language === "hk" ? "zh-HK" : language === "cn" ? "zh-CN" : "en-US" } });
        case 2:
            resp = _context3.sent;
            return _context3.abrupt("return", resp.data);
        case 4:
        case "end": return _context3.stop();
    }
} }, _callee3); })); return _getWeChatPayRequest.apply(this, arguments); }
